var scope_0 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/17b173cd20f16eb75cc63e3cb977cfb8.js').default;
var scope_1 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/349e15de962b445575a9530aa234041e.js').default;
var scope_2 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/90b43a13bd5af5502b7b8cbfa005f28d.js').default;
var scope_3 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/93e1eed815dfb6644858c38673e69866.js').default;
var scope_4 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ae196ada28b49a328ba338239e9cba68.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    